import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../api/axiosInstance";
import { ICategories } from "../../../interfaces/Rights";
import { Pagination } from "../../../interfaces/Pagination";
import { IMediaAndContent } from "../../../interfaces/MediaAndContent";
const { REACT_APP_API_PATH } = process.env;

interface GetResearchsParams {
    page: number;
    search?: string;
    categoria?: string;
    fechaFrom?: string;
    fechaTo?: string;
    related_indicator?: string;
    id?: string;
}

//Intefaces de los gets

interface GetCategoriesResponse {
    categories: ICategories[];
}

interface GetResearchsResponse {
    researchs: IMediaAndContent[];
    pagination: Pagination;
}

interface getDetailAndRelatedResearchsResponse {
    detail: IMediaAndContent;
    related: IMediaAndContent[];
}

interface ErrorResponse {
    message: string;
    // otros campos relevantes del error
}

export const getResearchs = createAsyncThunk<GetResearchsResponse, GetResearchsParams, { rejectValue: ErrorResponse }>(
    "researchs/feature_researchs",
    async ({ page, search, categoria, fechaFrom, fechaTo, related_indicator, id }: GetResearchsParams) => {
        try {
            let url = `${REACT_APP_API_PATH}/monitor/researchs/feature_researchs?page=${page}&limit=10`;

            if (search) url += `&titulo=${search}`
            if (categoria) url += `&categoria=${categoria}`
            if (fechaFrom) url += `&fechaFrom=${fechaFrom}`
            if (fechaTo) url += `&fechaTo=${fechaTo}`
            if (related_indicator) url += `&related_indicator_id=${related_indicator}`
            if (id) url += `&id=${id}`

            const response = await axiosInstance.get(url);
            const data = response.data;

            return {
                researchs: data.data,
                pagination: data.pagination
            }

        } catch (error: any) {
            return {
                researchs: [],
                pagination: { totalItems: 0, currentPage: 0, totalPages: 0 }
            }
        }
    }
);

export const getDetailAndRelatedresearchs = createAsyncThunk<getDetailAndRelatedResearchsResponse, string, { rejectValue: ErrorResponse }>(
    "researchs/related_researchs",
    async (id: string, thunkAPI) => {
        try {
            const response = await axiosInstance.get(`${REACT_APP_API_PATH}/monitor/researchs/related_researchs?id=${id}`)
            const data = response.data
            return {
                detail: data.data.activity,
                related: data.data.related
            }
        } catch (error: any) {
            return {
                detail: [],
                related: null,
            }
        }
    }
);

export const getDetailAndRelatedresearchsByDerechoId = createAsyncThunk<getDetailAndRelatedResearchsResponse, string, { rejectValue: ErrorResponse }>(
    "researchs/related_researchsByDerecho",
    async (id: string, thunkAPI) => {
        try {
            const response = await axiosInstance.get(`${REACT_APP_API_PATH}/monitor/researchs/related_researchsByDerecho?derecho_id=${id}`)
            const data = response.data
            return {
                detail: data.data.activity,
                related: data.data.related
            }
        } catch (error: any) {
            return {
                detail: [],
                related: null,
            }
        }
    }
);

export const getCategories = createAsyncThunk<GetCategoriesResponse, void, { rejectValue: ErrorResponse }>(
    "researchs/categories",
    async (_, thunkAPI) => {
        try {
            const response = await axiosInstance.get(`${REACT_APP_API_PATH}/categorias/activas`)
            const data = response.data
            return {
                categories: data.data,
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const getMajorResearchs = createAsyncThunk(
    'research/getMajorResearchs',
    async () => {
        const response = await axiosInstance.get(`${REACT_APP_API_PATH}/monitor/researchs/feature_researchs?page=1&limit=3`);
        return {
            researchs: response.data.data,
        }
    }
);